// client/src/components/influencer/InfluencerSecbar.js
// 컨텍스트 칩바 (≤1024px) — 하단 탭바(1차)의 현재 탭에 속한 하위 화면만 노출하는 2차 내비.
// 마케터 확정 사양(secbar-compare.html) 미러: 홈·지원 탭은 숨김, 민트 활성(ib-theme), sticky, 활성 칩 자동 스크롤.
import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { TAB_OF, SUBNAV } from './influencerMybizNav';

function InfluencerSecbar() {
  const nav = useNavigate();
  const location = useLocation();
  const barRef = useRef(null);

  const sub = new URLSearchParams(location.search).get('sub');
  const group = SUBNAV[TAB_OF[sub]] ? TAB_OF[sub] : null;

  // 진입 시 활성 칩을 가운데로
  useEffect(() => {
    const active = barRef.current?.querySelector('.is-active');
    if (active?.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'center' });
  }, [group, sub]);

  if (!group) return null;

  return (
    <nav className="mb-secbar" ref={barRef} aria-label="현재 탭 하위 메뉴">
      {SUBNAV[group].map(([label, itemSub]) => (
        <button
          key={itemSub}
          type="button"
          className={sub === itemSub ? 'is-active' : ''}
          onClick={() => nav(`/influencer/mybiz?sub=${itemSub}`)}
        >
          {label}
        </button>
      ))}
    </nav>
  );
}

export default InfluencerSecbar;
